/**
 * Created by matheusmorett on 23/08/18.
 */
import React, {Component} from 'react';

import './GridItem.scss';

export default class GridItem extends Component {
    static defaultProps = {
        md: false,
        sm: false,
        xs: false,
        className: ""
    };

    render() {

        let md;
        let sm;
        let xs;
        let lg;

        if (this.props.md) {
            md = "md-" + this.props.md
        }

        if (this.props.sm) {
            sm = "sm-" + this.props.sm
        }

        if (this.props.xs) {
            xs = "xs-" + this.props.xs
        }

        if (this.props.lg) {
            lg = "lg-" + this.props.lg
        }

        return (
            <div className={"GridItem2 " + md + ' ' + sm + ' ' + xs + ' ' + lg + ' ' +
                (this.props.verticalCenter && "vertical-center") + ' ' +
                (this.props.horizontalCenter && "horizontal-center")
                + ' ' + this.props.className} style={{
                    ...this.props.style
                }}>
                {this.props.children}
            </div>
        )
    }

}


